import 'flickity/dist/flickity.pkgd'
import axios from 'axios';

jQuery(document).ready(function() {

    const splashSlider = jQuery('.splash__holder'),
        splashSlides = jQuery('.splash__holder .splash')

    let splashVideoPrev

    if (splashSlider.length > 0 && splashSlides.length > 1) {

        var carousel = splashSlider.flickity({
            cellSelector: '.splash',
            prevNextButtons: false,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            wrapAround: true,
            pageDots: true,
            cellAlign: 'center',
            // draggable: true,
            arrowShape: {
                x0: 80,
                x1: 60, y1: 50,
                x2: 65, y2: 45,
                x3: 20
            }
        })

        jQuery(".splash").addClass("pageloaded");

        carousel.on('change.flickity', function (event, index) {
            // Check if the index is odd or even
            if (index % 2 === 0) {
                splashSlider.removeClass('odd_slider_active')
            } else {
                splashSlider.addClass('odd_slider_active')
            }
        });

        // previous
        jQuery('.button--previous').on( 'click', function() {
          carousel.flickity('previous');
        });
        jQuery('.button--previous').on( 'keypress', function(e) {
            if(e.which == 13) {
                carousel.flickity('previous');
                setTimeout(() => {
                    const splashSlides = jQuery('.splash__holder .splash')
                    splashSlides.each(function( e ) {
                        // console.log('it happens?');
                        if( !jQuery(this).hasClass('is-selected') ){
                            jQuery(this).find('*').attr('tabindex', '-1')
                        }else{
                            jQuery(this).find('.splash__action').attr('tabindex', '0')
                        }
                    })
                }, 500);
            }
        });
        // next
        jQuery('.button--next').on( 'click', function() {
          carousel.flickity('next');
        });
        jQuery('.button--next').on( 'keypress', function(e) {
            if(e.which == 13) {
                carousel.flickity('next');
                setTimeout(() => {
                    const splashSlides = jQuery('.splash__holder .splash')
                    splashSlides.each(function( e ) {
                        if( !jQuery(this).hasClass('is-selected') ){
                            jQuery(this).find('*').attr('tabindex', '-1')
                        }else{
                            jQuery(this).find('.splash__action').attr('tabindex', '0')
                        }
                    })
                }, 500);
            }
        });

    }

    let sections = jQuery('.fp-cards__section')

    sections.each( function( index ) {

        const cardsSlider = jQuery('.fp-cards__cards',this),
            cardsSlide = jQuery('.block', this)

        if (cardsSlider.length > 0 && cardsSlide.length > 1) {

            var carousel = cardsSlider.flickity({
                cellSelector: '.block',
                prevNextButtons: false,
                autoPlay: false,
                pauseAutoPlayOnHover: false,
                wrapAround: false,
                pageDots: false,
                groupCells: true,
                contain: true,
                cellAlign: 'left',
                // lazyLoad: 2,
                draggable: true,
                arrowShape: {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 65, y2: 45,
                    x3: 20
                }
            })

            jQuery(".block").addClass("pageloaded");

            let vm = this

            carousel.on( 'dragEnd.flickity', function() {

                const progressionBarHolder = jQuery(this)[0].nextElementSibling
                const intro = jQuery(this)[0].previousElementSibling

                updateProgress(carousel, jQuery('.progression__bar__completed', progressionBarHolder), jQuery('.button--next',intro), jQuery('.button--previous',intro) )
            });

            updateProgress(carousel, jQuery('.progression__bar__completed', this), jQuery('.button--next', this), jQuery('.button--previous', this) )

            // previous
            jQuery('.button--previous', this).on( 'click', function() {
              carousel.flickity('previous');

              console.log(jQuery(this))
              updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--previous', vm)[0].nextElementSibling, jQuery('.button--previous', vm) )
            });
            jQuery('.button--previous', this).on( 'keypress', function(e) {
                if(e.which == 13) {
                    carousel.flickity('previous');
                    setTimeout(() => {
                        const cardsSlide = jQuery('.block', vm)
                        updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--previous', vm)[0].nextElementSibling, jQuery('.button--previous', vm) )
                        // cardsSlide.each(function( e ) {
                        //     // console.log('it happens?');
                        //     if( !jQuery(this).hasClass('is-selected') ){
                        //         jQuery(this).find('*').attr('tabindex', '-1')
                        //     }else{
                        //         jQuery(this).find('.button').attr('tabindex', '0')
                        //     }
                        // })
                    }, 500);
                }
            });
            // next
            jQuery('.button--next', this).on( 'click', function() {
                carousel.flickity('next');

                updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--next', vm), jQuery('.button--next', vm)[0].previousElementSibling )
            });
            jQuery('.button--next', this ).on( 'keypress', function(e) {
                if(e.which == 13) {
                    carousel.flickity('next');
                    setTimeout(() => {

                        updateProgress(carousel, jQuery('.progression__bar__completed', vm), jQuery('.button--next', vm), jQuery('.button--next', vm)[0].previousElementSibling )

                        // const cardsSlide = jQuery('.block', vm)
                        // cardsSlide.each(function( e ) {
                        //     if( !jQuery(this).hasClass('is-selected') ){
                        //         jQuery(this).find('*').attr('tabindex', '-1')
                        //     }else{
                        //         jQuery(this).find('.button').attr('tabindex', '0')
                        //     }
                        // })

                    }, 500);
                }
            });
        }

    })

    function updateProgress(carousel, currentProgressBar, currentNextButton, currentPrevButton ){

        const selectedIndex = jQuery(carousel).data('flickity').selectedIndex;
        const slideCount = jQuery(carousel).data('flickity').slides.length;

        const progressPercentage = ((selectedIndex + 1) / slideCount) * 100

        currentProgressBar.css( 'width', `${progressPercentage}%` );

        if(currentNextButton){
            if(selectedIndex + 1 == slideCount){
                jQuery(currentNextButton).addClass('inactive-button')
            }else{
                jQuery(currentNextButton).removeClass('inactive-button')
            }
        }

        if(currentPrevButton){
            if(selectedIndex == 0){
                jQuery(currentPrevButton).addClass('inactive-button')
            }else{
                jQuery(currentPrevButton).removeClass('inactive-button')
            }
        }

    }

    jQuery('.campaign').each(function () {
        // Get the text content of the .campaign element
        var textContent = jQuery(this).text();

        // Use a regular expression to find all date patterns in the text content
        var dates = textContent.match(/\d{2}\/\d{2}\/\d{4}/g);

        // Wrap each date in a <div> tag
        for (var i = 0; i < dates.length; i++) {
            var date = dates[i];

            var formattedDate = formatDate(date);

            textContent = textContent.replace(date, '');
        }

        textContent = textContent.replace(' - ', '');

        // Get the href attribute from the first <a> tag inside the .campaign element
        var hrefAttribute = jQuery(this).find('a:first').attr('href');

        // Wrap the text content in an <a> tag with the same href attribute
        var newHtml = '<a class="fp-newsletter__latest__block" href="' + hrefAttribute + '">' + '<p>' + formattedDate + '</p>' + '<h5>' + textContent + '</h5><span class="general-icon light-background">' + window.ico_external + '</span></a>';

        // Replace the content of the .campaign element with the new HTML
        jQuery(this).html(newHtml);
    });

    function formatDate(inputDate) {
        var dateParts = inputDate.split('/');

        var month = parseInt(dateParts[1], 10);

        var year = parseInt(dateParts[2], 10);

        var formattedDate = new Date(year, month - 1); // Month is zero-based

        var options = { month: 'long', year: 'numeric' };
        if( window.lang == 'fr' ){
            return formattedDate.toLocaleDateString('fr-FR', options);
        }else{
            return formattedDate.toLocaleDateString('en-US', options);
        }

    }

})
